module.exports = __webpack_public_path__ + "img/ic_sex.33b4c760.png";